import React, { useEffect, useState } from "react";
import { Button, Modal } from "antd";
import "./bidfreemodal.scss";
import { PATHS } from "@config/constants";
import { useTranslation } from "react-i18next";
import { getShowFreeBidPopup, setShowFreeBidPopup } from "@utils/cookie";

const BidFreeModal = (prop) => {
  const { t } = useTranslation();
  const [isModalVisible, setIsModalVisible] = useState(false)
  const handleOk = () => {
    setShowFreeBidPopup('0', prop.userId);
    window.location.href = PATHS.BID2_PAGE;
  };

  const handleCancel = () => {
    setShowFreeBidPopup('0', prop.userId);
    setIsModalVisible(false);
  };

  useEffect(() => {
    const isShowFreeBidPopup = getShowFreeBidPopup(prop.userId)
    if (isShowFreeBidPopup === '0') {
      return
    } else {
      setIsModalVisible(true)
    }
  }, [prop.userId]);

  return (
    <Modal
      centered
      visible={isModalVisible}
      onOk={handleOk}
      onCancel={handleCancel}
      width="456px"
      footer={[
        <Button style={{ width: 'auto' }} key="submit" type="primary" onClick={handleOk}>
          {t("bid.bid_now")}
        </Button>,
      ]}>
      <h1>{t("bid.free_bid_title")}</h1>
      <div className="ant-modal-body-user">
        {prop.message}
      </div>
    </Modal>
  );
};

export default BidFreeModal;
